import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Skeleton } from '@maxus/website/components'
import { cn } from '@maxus/website/utils'

import { breadcrumbStore } from './breadcrumb-store'

export const Breadcrumb = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <>
      {breadcrumbStore.crumbs.map((item, index) => {
        const isLast = index === breadcrumbStore.crumbs.length - 1

        return (
          <span key={item.key} className="flex items-center gap-3">
            {item.loading ? (
              <Skeleton className="h-4 w-20" />
            ) : item.to ? (
              <button
                className={cn(
                  'rounded-sm transition hover:text-text-primary',
                  isLast ? 'text-text-secondary' : 'text-text-tertiary',
                )}
                onClick={() => navigate(item.to!)}
                type="button"
              >
                {item.label ?? t('Untitled')}
              </button>
            ) : (
              <span className={isLast ? 'text-text-secondary' : undefined}>{item.label ?? t('Untitled')}</span>
            )}
            {!isLast && <span className="mr-3 text-text-quiet">/</span>}
          </span>
        )
      })}
    </>
  )
})
